/*
 * Copyright (c) 2018 Helvia Technologies PC <contact@helvia.io>
 */

// Core imports
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useParams } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

// Component imports
import { Button, Col, Form, Input, Row } from 'antd';
import { useCreateBackupMutation } from '../../store/backups/backupsApi';

const BackupForm = ({ onSuccess }) => {
  const [form] = Form.useForm();
  const { tenantId, orgId } = useParams();
  const { t } = useTranslation();

  const [createBackup, { isLoading: isCreatingBackup }] = useCreateBackupMutation({ fixedCacheKey: 'createBackup-shared' });

  useEffect(() => {
    // Reset data on unmount
    return () => form.resetFields();
  }, []);

  const onSubmit = async (values) => {
    const isCreated = await createBackup({ orgId, tenantId, data: values }).unwrap();

    if (isCreated) {
      onSuccess();
      form.resetFields();
    }
  };

  const renderForm = () => {
    return (
      <Form
        name="backupForm"
        layout="vertical"
        onFinish={onSubmit}
        form={form}
      >
        <Row gutter={16} className="mb-3">
          <Col xs={24}>
            <Form.Item
              name="description"
              label={t('Note')}
            >
              <Input.TextArea
                placeholder={t('(Optional) Type a note for the backup')}
                size="large"
                rows={3}
              />
            </Form.Item>
          </Col>
        </Row>

        <Row justify="end">
          <Button
            type="primary"
            htmlType="submit"
            size="large"
            loading={isCreatingBackup}
          >
            {t('Create Backup')}
          </Button>
        </Row>
      </Form>
    );
  };

  return (
    <Row gutter={24}>
      <Col xs={24}>
        {renderForm()}
      </Col>
    </Row>
  );
};

BackupForm.propTypes = {
  onSuccess: PropTypes.func
};

export default BackupForm;
